import { useContext } from 'react';
import ConfigContext from '../contexts/ConfigContext';

export default function SlideProgressSunnyBot({ percentage }: any) {
  const { isDebrandedVersion, features } = useContext(ConfigContext);

  return (
    <div
      className={`relative flex justify-end items-center ${
        features.showLanderConcept ? 'mt-[-10px] mb-12' : 'my-4'
      } md:my-0 md:mt-8`}>
      <div className="grow">
        <div
          className={`bg-[#DCDCD6] h-[3px] md:h-[6px] rounded-full relative`}>
          <div
            className={`${
              isDebrandedVersion ? 'bg-[#5ecf7f]' : 'bg-enph-orange'
            } h-full absolute left-0 top-0 rounded-full`}
            style={{
              width: ` ${percentage || 0}%`,
              transition: 'width 0.5s',
            }}></div>
          <div
            className={`${
              isDebrandedVersion ? 'bg-[#5ecf7f]' : 'bg-enph-orange'
            } h-[5px] md:h-[10px] w-[5px] md:w-[10px] top-[-1px] md:top-[-2px] absolute rounded-full`}
            style={{
              left: ` ${percentage - 1 || 0}%`,
              transition: 'left 0.5s',
            }}></div>
        </div>
      </div>
    </div>
  );
}
